<template>
    <button id="SEARCH" name="SEARCH" class="btn" aria-label="SEARCH" :data-command="$t('searchButton')">
        <img src="/images/icons/search.svg" alt="" role="img" aria-hidden="true" />
        <label>{{ $t('searchButton') }}</label>
    </button>
</template>
<script>
export default {};
</script>
